import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import { useMediaQuery } from '@mui/material';

import LOGO_KYUDEN from '../_img/logo_kyuden.svg';
import { RequestButtonFullWidth } from "../style/button";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState('');
  const { login, loading, error, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:600px)");

  // SMSのURL経由でログインした場合、自動的にリダイレクト
  const from = location.state?.from || '/';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');

    // 基本的な入力チェック
    if (!email || !password) {
      setFormError('メールアドレスとパスワードを入力してください');
      return;
    }

    try {
      // パスワードを SHA-256 ハッシュ化
      const encoder = new TextEncoder();
      const dataBuffer = encoder.encode(password);
      const hashBuffer = await crypto.subtle.digest("SHA-256", dataBuffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashedPassword = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');      // ログイン処理

      await login(email, hashedPassword);
      // ログイン成功時にホームページにリダイレクト
      navigate('/');
    } catch (err) {
      // エラーは AuthContext で既に処理されています
      console.error('Login failed:', err);
    }
  };

  return (
    <Container
      component="main"
      maxWidth="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh' // ビューポートの高さいっぱいに
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          // width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <img
            src={LOGO_KYUDEN}
            alt="九州電力ロゴ"
            style={{
              height: isMobile ? 25 : 40,
              marginRight: 10
            }}
          />
          <Typography
            component="h1"
            variant="h5"
            sx={{
              fontSize: { xs: '0.9rem', sm: '1.5rem' },
              fontWeight: 'bold'
            }}
          >
            自然災害リスク対応支援システム
          </Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }}>
          {(error || formError) && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {formError || error}
            </Alert>
          )}
          <TextField
            margin="normal"
            fullWidth
            id="email"
            label="メールアドレス"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
          <TextField
            margin="normal"
            fullWidth
            name="password"
            label="パスワード"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
          <RequestButtonFullWidth
            size="large"
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'ログイン'}
          </RequestButtonFullWidth>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;